import * as types from "@/store/mutation-types";

const state = {
  tags: [],
  categories: [],
  currentArticle: {
    data: {},
    products: [],
  },
}

const actions = {
  setArticles({ commit }, array) {
    commit(types.FETCH_ARTICLES_SUCCESS, array)
  },
  fetchCurrentArticle({ commit }, array) {
    commit(types.FETCH_EDIT_ARTICLE_SUCCESS, array)
  }
}

const mutations = {
  [types.FETCH_ARTICLES_SUCCESS](state, array) {
    const [categories, tags] = array

    state.tags = tags
    state.categories = categories
  },
  [types.FETCH_EDIT_ARTICLE_SUCCESS](state, array) {
    const [ article, products ] = array;

    state.currentArticle.data = article.data
    state.currentArticle.products = products.data
  }
}

const getters = {
  categories: state => state.categories,
  tags: state => state.tags,
  currentArticle: state => state.currentArticle
}

export default {
  state,
  actions,
  mutations,
  getters,
}
